import {Breadcrumb, Col, Divider, Flex, Row} from "antd";
import React, {useEffect, useState} from "react";
import axios from "axios";
import Markdown from 'react-markdown'
import {NavLink} from "react-router-dom";
import {RightOutlined} from "@ant-design/icons";

function Products() {

    const [content, setContent] = useState({});

    const [skeleton, setSkeleton] = useState(true);

    const apiKey = process.env.REACT_APP_STRAPI_CMS_API_KEY;

    const toggleSceleton = (value, key) => {
        if (key in value) {
            setSkeleton(false);
        } else {
            setSkeleton(true);
        }
    }

    const getProducts = async () => {
        const response = await axios.get(
            process.env.REACT_APP_STRAPI_URL + "/api/product/?populate[0]=Products&populate[1]=Products.Logo&populate[2]=Products.LogoTwo",
            {
                headers: {
                    'Authorization': 'Bearer ' + apiKey
                }
            }
        )
        console.log(response.data.data.attributes);
        const content = response.data.data.attributes;

        setContent(content);
        toggleSceleton(content, 'Title');
    }

    useEffect(() => {
        getProducts().then(r => {});
    }, []);

    return (
            <>
                <Row gutter={24} className={"Content"} style={{paddingBottom: 0}}>
                    <Col span={12}>
                        <h1>{content.Title}</h1>
                    </Col>
                    <Col span={12} style={{textAlign: "right"}}>
                        <Breadcrumb
                            style={{float: "right"}}
                            items={[
                                {
                                    href: '/',
                                    title: (
                                        <>
                                            <span>Home</span>
                                        </>
                                    ),
                                },
                                {
                                    title: 'Products',
                                },
                            ]}
                        />
                    </Col>
                </Row>

                <Row gutter={24} className={"Content"} style={{textAlign: "center", paddingTop: 0}}>
                    <Col span={24}>
                        <h2>{content.PageSubTitle}</h2>
                        <Divider className={"TransitionColors"} orientation="right">{content.Quote}</Divider>
                    </Col>
                </Row>

                {
                    (content?.Products ?? []).map((product, value) => {
                        return <Row
                                    className={"Content"}
                                    key={value}
                                    gutter={48}
                                    style={{textAlign: "center"}}>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <img
                                    style={{maxHeight: 54, filter: "grayscale(100%)"}}
                                    src={process.env.REACT_APP_STRAPI_URL + product.Logo.data.attributes.url} />
                                <h2 level={5}>{product.Title}</h2>
                                <h3>{product.SubTitle}</h3>
                                <p style={{padding: "0 96px"}}>{product.Description}</p>
                                <small>
                                    <NavLink
                                        style={{textTransform: "uppercase", color: "black"}}
                                        to={product.ButtonLink}>
                                            {product.ButtonTitle}
                                        <RightOutlined/>
                                    </NavLink>
                                </small>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <img
                                    style={{maxHeight: 54, filter: "grayscale(1)"}}
                                    src={process.env.REACT_APP_STRAPI_URL + product.LogoTwo.data.attributes.url}/>
                                <h2>{product.TitleTwo}</h2>
                                <h3>{product.SubTitleTwo}</h3>
                                <p style={{padding: "0 96px"}}>{product.DescriptionTwo}</p>
                                <small>
                                    <NavLink
                                        style={{textTransform: "uppercase", color: "black"}}
                                        to={product.ButtonLinkTwo}>
                                        {product.ButtonTitleTwo}
                                        <RightOutlined/>
                                    </NavLink>
                                </small>
                            </Col>
                        </Row>
                    })
                }
            </>
    )
}

export default Products